export enum MessageStatus {
  Unread = 0,
  Read = 1
}
